













import {defineComponent} from "@vue/composition-api";

export default defineComponent({
    props: {
        url: {
            type: String,
            default: 'https://utmtool.com'
        }
    },
    setup(props) {
        const getUrl = (medium: string) => {
            const utmString = 'utm_campaign=website_share&utm_source=website&utm_medium=' + medium;
            const url = props.url + (props.url.includes('?') ? '&' : '?') + utmString;
            return encodeURIComponent(url);
        }
        const text = encodeURIComponent('I found a great tool to help you with UTM Tags! @UTMTool');

        const facebook = 'https://www.facebook.com/sharer/sharer.php?u=' + getUrl('facebook') + '';
        const twitter = 'https://twitter.com/intent/tweet?url=' + getUrl('twitter') + '&text=' + text;
        const linkedin = 'https://www.linkedin.com/shareArticle?mini=true&url=' + getUrl('linkedin');
        const pinterest = 'https://pinterest.com/pin/create/button/?url=' + getUrl('pinterest') + '&media=&description=' + text;
        const mail = 'mailto:info@example.com?&subject=&cc=&bcc=&body=' + getUrl('mail') + '%0A' + text;

        return {
            facebook,
            twitter,
            linkedin,
            pinterest,
            mail
        }
    }
});
